/* ブロック */
import React from 'react';
import { Card } from 'react-bootstrap';
var Block = function (_a) {
    var label = _a.label, content = _a.content;
    return (React.createElement(Card, { className: "block mx-auto col-xs-11 col-sm-11 col-md-8 col-11 px-0" },
        React.createElement(Card.Header, { className: "block-header" }, label),
        React.createElement(Card.Body, null,
            React.createElement("div", null, content))));
};
export default Block;
